import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { change } from 'redux-form';
import ListSelectEditorField from './ListSelectEditorField';

export default class ListSelectEditor extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    inlineTypeOptions: PropTypes.object,
    input: PropTypes.object,
    multi: PropTypes.bool,
    propTypeOptions: PropTypes.object,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  componentDidMount = () => {
    const { uid, defaultValue, input } = this.props;
    const { dispatch } = this.props.meta;
    if (defaultValue) dispatch(change(uid, input.name, defaultValue));
  };

  render() {
    const {
      containerClassName,
      containerStyle,
      inlineTypeOptions,
      input,
      multi,
      propTypeOptions,
      wrapperClassName,
      wrapperStyle,
    } = this.props;

    const typeOptions = propTypeOptions || inlineTypeOptions;

    // console.log('typeOptions', inputName, selectOptions, this.props);
    const displayEditor = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <div className={containerClassName} style={containerStyle}>
          <ListSelectEditorField
            input={input}
            multi={multi}
            typeOptions={typeOptions}
          />
        </div>
      </div>
    );
    return displayEditor;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListSelectEditor.js